let baseurls = process.env.API_BASEURL
if (process.env.NODE_ENV === 'development') {
  baseurls = ''
}
export const baseurl = baseurls



// WEBPACK FOOTER //
// ./src/components/url.js